import clearSelectedConversationInModule from 'mini-mail-reading-pane-store/lib/actions/clearSelectedConversationInModule';
import closeItemReadingPane from 'mini-mail-reading-pane-store/lib/actions/closeItemReadingPane';
import ECViewState from 'mini-mail-bootstrap/lib/routing/viewStateHandler';
import goBackToListView from 'mini-mail-list-store/lib/actions/goBackToListView';
import signalReadingPaneClosed from 'mini-mail-reading-pane-store/lib/actions/signalReadingPaneClosed';
import { getReadingPaneStore } from 'mini-mail-reading-pane-store/lib/store/Store';
import { lazyHideBottomSheet } from 'mini-bottom-sheet-animated';

export default function closeReadingPane(): void {
    const mailListContainer = document.getElementById('mailListMainContainer');
    if (mailListContainer) {
        mailListContainer.style.visibility = 'visible';
    }

    signalReadingPaneClosed();
    if (ECViewState.shouldItemViewBeShown()) {
        ECViewState.resetValues();
        lazyHideBottomSheet.importAndExecute();
        closeItemReadingPane();
        goBackToListView();
    } else {
        if (getReadingPaneStore().itemReadingPaneViewState) {
            closeItemReadingPane();
        } else {
            clearSelectedConversationInModule();
            lazyHideBottomSheet.importAndExecute();
        }
    }
}
